import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { bem } from 'helpers/class-name';
import { Input, Textarea } from 'components/Form';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import messages from '../../ScheduleForm.messages';
import './AddClassModal.scss';

const { block, element } = bem('add-class-modal');

const AddClassModal = ({ handleSubmit }) => (
  <Confirm
    cancelNode={<Message message={messages.modals.cancel} />}
    acceptNode={<Message message={messages.modals.save} />}
    title={<Message message={messages.modals.addClass.title} />}
    className={block()}
    isOpen
    onConfirm={handleSubmit}
    size="complex">
    <div className={element('content')}>
      <div className="grid">
        <div className={element('fieldset', 'grid__item')}>
          <Field
            id="name"
            name="name"
            type="text"
            placeholder={messages.modals.addClass.placeholderClassName}
            label={messages.modals.addClass.labelClassName}
            component={Input}
          />
        </div>
        <div className={element('fieldset', 'grid__item')}>
          <Field
            id="description"
            inputClassName={element('description-field')}
            name="description"
            component={Textarea}
            placeholder={messages.modals.addClass.placeholderClassDescription}
            label={messages.modals.addClass.labelClassDescription}
          />
        </div>
      </div>
    </div>
  </Confirm>
);

AddClassModal.propTypes = {
  handleSubmit: PropTypes.func,
};

export default AddClassModal;
